import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import UserProfile from "../models/userProfile";
import {Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import AppState from 'src/app/store';
import { selectUserProfile } from 'src/app/store/userProfile/userProfile.selector';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private readonly sub: Subscription;
  private cultureCode: string;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.sub = this.store.select(selectUserProfile).subscribe(userProfile => {
      this.cultureCode = userProfile?.cultureCode;
      if (userProfile?.language) {
        this.translate.use(userProfile.language);
      }
    });
  }
}
